import { render, staticRenderFns } from "./OnboardingDomainInstantVerificationModal.vue?vue&type=template&id=2620a460&scoped=true"
import script from "./OnboardingDomainInstantVerificationModal.vue?vue&type=script&lang=js"
export * from "./OnboardingDomainInstantVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDomainInstantVerificationModal.vue?vue&type=style&index=0&id=2620a460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620a460",
  null
  
)

export default component.exports